import i18next from 'i18next';

i18next.addResources('es', 'projects-iirsa', {
  backToHome: 'Volver al Inicio'
});
